export enum SpecialItem {
  appliance = 'appliance',
  largeAppliance = 'largeAppliance',
  commercialFreezer = 'commercialFreezer',
  sportEquipment = 'sportEquipment',
  uprightPiano = 'uprightPiano',
  babyGrandPiano = 'babyGrandPiano',
  grandPiano = 'grandPiano',
  poolTable = 'poolTable',
  marbleTableTop = 'marbleTableTop',
  heavyItem200 = 'heavyItem200',
  heavyItem300 = 'heavyItem300',
  heavyItem400 = 'heavyItem400',
}
